import {
  APIFieldGroup,
  APIFieldGroupAttributes,
  ArdoqId,
  UpdateFieldGroupBody,
} from '@ardoq/api-types';
import { crudApi, fetchJson, Method, toRequestOptions } from './api';
import { ApiResponse } from './types';

export type UpdateFieldGroupPayload = { _id: ArdoqId } & UpdateFieldGroupBody;

const update = ({
  _id,
  ...body
}: UpdateFieldGroupPayload): ApiResponse<APIFieldGroup> => {
  const request = new Request(
    `/api/field-group/${_id}`,
    toRequestOptions(Method.PUT, body)
  );
  return fetchJson<APIFieldGroup>(request);
};

const reorder = (orderedIds: ArdoqId[]): ApiResponse<APIFieldGroup[]> => {
  const request = new Request(
    '/api/field-group/order',
    toRequestOptions(Method.PUT, { orderedIds })
  );
  return fetchJson<APIFieldGroup[]>(request);
};

export const fieldGroupApi = {
  ...crudApi<APIFieldGroup, APIFieldGroupAttributes>('field-group'),
  update,
  reorder,
};
